import "core-js/modules/es.array.map.js";
import React, { Fragment } from 'react';
import { Carousel, breakPointsSet1 } from '../../Carousel';
import { Section } from '../../Section';
import { PodcastCard } from '../../Podcasts/PodcastCard';
import { VideoCard, VideoCardSkeleton } from './../VideoCard';
export var VideosCarousel = function VideosCarousel(props) {
  var _props$type = props.type,
    type = _props$type === void 0 ? 'video' : _props$type,
    fetching = props.fetching,
    videos = props.videos,
    fetched = props.fetched,
    alwaysShowControls = props.alwaysShowControls;
  if (fetched && !videos.length) {
    return null;
  }
  return React.createElement(Fragment, null, React.createElement(Section, {
    title: props.title || null,
    subtitle: props.subtitle || null,
    bottomMargin: true,
    link: props.link
  }, fetching ? React.createElement(Carousel, {
    breakpoints: breakPointsSet1,
    alwaysShowControls: alwaysShowControls
  }, [0, 1, 2, 3, 4, 5, 6].map(function (item) {
    return React.createElement(VideoCardSkeleton, {
      key: item
    });
  })) : React.createElement(Carousel, {
    breakpoints: breakPointsSet1,
    alwaysShowControls: alwaysShowControls
  }, type === 'podcast' ? videos.map(function (video, index) {
    return React.createElement(PodcastCard, {
      key: index,
      podcast: video
    });
  }) : videos.map(function (video, index) {
    return React.createElement(VideoCard, {
      key: index,
      withDate: true,
      video: {
        vendor: video.video.vendor,
        id: video.video.id,
        title: video.title,
        subtitle: video.subtitle,
        date: video.date
      }
    });
  }))));
};